import { useI18nNavigate } from "@/hooks/use-i18n-navigate";
import {
  iamTokenManager,
  iamAccountManager,
  iamEmailManager,
  iamFirstLoginManager,
  iamEmailSessionIdManager,
  creationProductManager,
  creationVideoManager,
  routeLastVisitManager,
  routeLastVisitCreationManager,
  iamVerifyCodeManager,
  iamInviteIamTokenManager,
  iamInviteIamEmailManager,
  assetsActorManager,
  assetsVoiceManager,
  agentManager,
  iamTeamManager,
  imaCookieManager,
} from "@/manager";
import { logger } from "@/utils/logger";

export const useLogout = () => {
  logger.info("hooks: useLogout");
  const navigate = useI18nNavigate();

  // 退出登录处理函数
  const handleLogout = () => {
    logger.info("hooks: useLogout handleLogout");
    try {
      // 清除所有用户相关的缓存
      iamAccountManager.clear(); // 清除账户信息
      iamTokenManager.clear(); // 清除Token
      iamInviteIamTokenManager.clear(); // 清除邀请Token
      iamInviteIamEmailManager.clear(); // 清除邀请邮箱
      iamEmailManager.clear(); // 清除邮箱信息
      iamEmailSessionIdManager.clear(); // 清除邮箱会话ID
      iamFirstLoginManager.clear(); // 清除首次登录状态
      iamVerifyCodeManager.clear(); // 清除验证码
      creationProductManager.clear(); // 清除创建产品信息
      creationVideoManager.clear(); // 清除视频创建信息
      routeLastVisitManager.clear(); // 清除最近访问信息
      routeLastVisitCreationManager.clear(); // 清除最近访问创建信息
      assetsActorManager.clear(); // 清除资产演员缓存
      assetsVoiceManager.clear(); // 清除资产音频缓存
      agentManager.clear(); // 清除智能体缓存
      iamTeamManager.clear(); // 清除团队缓存
      imaCookieManager.clear(); // 清除 Cookie
      // 直接全部清除 最近一次访问也不要
      window.localStorage.clear();
      console.log("sign out success");
    } catch (error) {
      console.error("sign out error:", error);
    } finally {
      // 导航到登录页面
      navigate("/login/");
    }
  };

  return {
    handleLogout,
  };
};
